export const pokedexGen3 = {
  "pokedex252": "Geckarbor",
  "pokedex253": "Reptain",
  "pokedex254": "Gewaldro",
  "pokedex255": "Flemmli",
  "pokedex256": "Jungglut",
  "pokedex257": "Lohgock",
  "pokedex258": "Hydropi",
  "pokedex259": "Moorabbel",
  "pokedex260": "Sumpex",
  "pokedex261": "Fiffyen",
  "pokedex262": "Magnayen",
  "pokedex263": "Zigzachs",
  "pokedex264": "Geradaks",
  "pokedex265": "Waumpel",
  "pokedex266": "Schaloko",
  "pokedex267": "Papinella",
  "pokedex268": "Panekon",
  "pokedex269": "Pudox",
  "pokedex270": "Loturzel",
  "pokedex271": "Lombrero",
  "pokedex272": "Kappalores",
  "pokedex273": "Samurzel",
  "pokedex274": "Blanas",
  "pokedex275": "Tengulist",
  "pokedex276": "Schwalbini",
  "pokedex277": "Schwalboss",
  "pokedex278": "Wingull",
  "pokedex279": "Pelipper",
  "pokedex280": "Trasla",
  "pokedex281": "Kirlia",
  "pokedex282": "Guardevoir",
  "pokedex283": "Gehweiher",
  "pokedex284": "Maskeregen",
  "pokedex285": "Knilz",
  "pokedex286": "Kapilz",
  "pokedex287": "Bummelz",
  "pokedex288": "Muntier",
  "pokedex289": "Letarking",
  "pokedex290": "Nincada",
  "pokedex291": "Ninjask",
  "pokedex292": "Ninjatom",
  "pokedex293": "Flurmel",
  "pokedex294": "Krakeelo",
  "pokedex295": "Krawumms",
  "pokedex296": "Makuhita",
  "pokedex297": "Hariyama",
  "pokedex298": "Azurill",
  "pokedex299": "Nasgnet",
  "pokedex300": "Eneco",
  "pokedex301": "Enekoro",
  "pokedex302": "Zobiris",
  "pokedex303": "Flunkifer",
  "pokedex304": "Stollunior",
  "pokedex305": "Stollrak",
  "pokedex306": "Stolloss",
  "pokedex307": "Meditie",
  "pokedex308": "Meditalis",
  "pokedex309": "Frizelbliz",
  "pokedex310": "Voltenso",
  "pokedex311": "Plusle",
  "pokedex312": "Minun",
  "pokedex313": "Volbeat",
  "pokedex314": "Illumise",
  "pokedex315": "Roselia",
  "pokedex316": "Schluppuck",
  "pokedex317": "Schlukwech",
  "pokedex318": "Kanivanha",
  "pokedex319": "Tohaido",
  "pokedex320": "Wailmer",
  "pokedex321": "Wailord",
  "pokedex322": "Camaub",
  "pokedex323": "Camerupt",
  "pokedex324": "Qurtel",
  "pokedex325": "Spoink",
  "pokedex326": "Groink",
  "pokedex327": "Pandir",
  "pokedex328": "Knacklion",
  "pokedex329": "Vibrava",
  "pokedex330": "Libelldra",
  "pokedex331": "Tuska",
  "pokedex332": "Noktuska",
  "pokedex333": "Wablu",
  "pokedex334": "Altaria",
  "pokedex335": "Sengo",
  "pokedex336": "Vipitis",
  "pokedex337": "Lunastein",
  "pokedex338": "Sonnfel",
  "pokedex339": "Schmerbe",
  "pokedex340": "Welsar",
  "pokedex341": "Krebscorps",
  "pokedex342": "Krebutack",
  "pokedex343": "Puppance",
  "pokedex344": "Lepumentas",
  "pokedex345": "Liliep",
  "pokedex346": "Wielie",
  "pokedex347": "Anorith",
  "pokedex348": "Armaldo",
  "pokedex349": "Barschwa",
  "pokedex350": "Milotic",
  "pokedex351": "Formeo",
  "pokedex352": "Kecleon",
  "pokedex353": "Shuppet",
  "pokedex354": "Banette",
  "pokedex355": "Zwirrlicht",
  "pokedex356": "Zwirrklop",
  "pokedex357": "Tropius",
  "pokedex358": "Palimpalim",
  "pokedex359": "Absol",
  "pokedex360": "Isso",
  "pokedex361": "Schneppke",
  "pokedex362": "Firnontor",
  "pokedex363": "Seemops",
  "pokedex364": "Seejong",
  "pokedex365": "Walraisa",
  "pokedex366": "Perlu",
  "pokedex367": "Aalabyss",
  "pokedex368": "Saganabyss",
  "pokedex369": "Relicanth",
  "pokedex370": "Liebiskus",
  "pokedex371": "Kindwurm",
  "pokedex372": "Draschel",
  "pokedex373": "Brutalanda",
  "pokedex374": "Tanhel",
  "pokedex375": "Metang",
  "pokedex376": "Metagross",
  "pokedex377": "Regirock",
  "pokedex378": "Regice",
  "pokedex379": "Registeel",
  "pokedex380": "Latias",
  "pokedex381": "Latios",
  "pokedex382": "Kyogre",
  "pokedex383": "Groudon",
  "pokedex384": "Rayquaza",
  "pokedex385": "Jirachi",
  "pokedex386": "Deoxys"
};